import { Cluster, Gpu } from '@typings';

export const as = <T = any>(source: any, defaultSource: T): T =>
  source ?? defaultSource;

/**
 * As any object
 */
as.o = <T = any>(source: any): T => as(source, {} as T);

/**
 * As any array
 */
as.a = <T = any>(source: any): T => as(source, [] as T);

/**
 * As cluster model
 */
as.c = <T = Cluster.Model>(source: any) => as.o<T>(source);

/**
 * As GPU model
 */
as.gpu = <T = Gpu.Profile>(source: any) => as.o<T>(source);
